import ClientTable from './ClientTable.vue';

export default ClientTable;
